export function resolveApiUrl(): string {
  const explicit = import.meta.env.VITE_API_URL as string | undefined;
  if (explicit) return explicit;
  if (typeof window !== 'undefined') {
    const { hostname } = window.location;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:8787';
    }
    if (hostname.endsWith('.pages.dev')) {
      return 'https://staging-api.vortexnav.com';
    }
  }
  return 'https://api.vortexnav.com';
}
